import React, { useState, useEffect, useContext, createContext } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, query, where, addDoc, setDoc, doc } from 'firebase/firestore'; // collection, addDoc, getDocs, query, where
import { getStorage } from 'firebase/storage';
import { generateRandomString } from './shared-functions.js';
import { getAuth, signInAnonymously, signInWithPopup, onAuthStateChanged, signOut, GoogleAuthProvider } from "firebase/auth";

const app = initializeApp({
  apiKey: "AIzaSyDNAlnUF-zX0gvOooTj6f8YrrVUK2h7rNw",
  authDomain: "molecule-climate.firebaseapp.com",
  projectId: "molecule-climate",
  storageBucket: "molecule-climate.appspot.com",
  messagingSenderId: "1000269840595",
  appId: "1:1000269840595:web:3159b3574f80f178ac9426",
  measurementId: "G-CKRVXEEK23"
});

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth();
const provider = new GoogleAuthProvider();

const authContext = createContext();

export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};

export const useAuth = () => {
  return useContext(authContext);
};

function useProvideAuth() {

  const [user, setUser] = useState(null);

  const signin = () => {
    return signInAnonymously(auth)
      .then((response) => {
        // console.log("user is", response);
        setUser(response.user);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  };

  const signout = () => {
    signOut(auth).then(() => {
      setUser(false);
    }).catch((error) => {
      // An error happened.
    });
  };

  const googleAuthenticate = () => {
    return signInWithPopup(auth, provider)
      .then(function(response) {
        let newuser = {
          uid: response.user.uid,
          // firstName: "",
          // lastName: "",
          // name: response.user.displayName,
          email: response.user.email,
          emailVerified: response.user.emailVerified,
          phoneNumber: response.user.phoneNumber,
          avatarUrl: response.user.photoURL,
          visibility: 'odoue4oGidmVhqlT8xHyEyH0oWPuAKxm',
          createdTs: Date.now(),
        }
        getDocs(query(collection(db, "users"), where("uid", "==", response.user.uid))).then((querySnapshot) => {
          if (querySnapshot.size > 0) {
            querySnapshot.forEach(function(doc) {
              let existinguser = doc.data()
              if (existinguser.avatarUrl === undefined) {
                existinguser.avatarUrl = response.user.photoURL
              }
              // if (existinguser.name === undefined || existinguser.name.length === 0) {
              //   existinguser.name = response.user.displayName
              // }
              existinguser.emailVerified = response.user.emailVerified
              existinguser.googleAccessToken = response.credential.accessToken
              setDoc(doc(db, "users", doc.id), existinguser).then(() => {
                 setUser(existinguser)
              })
            })
          } else {
            newuser.handle = generateRandomString(16).toLowerCase();
            addDoc(collection(db, "users"), newuser).then(() => {
              setUser(newuser)
            })
          }
        }).catch(error => {
          console.log(error);
          return error;
        })
        return response.user
      }).catch(error => {
        return error;
      });
  }

  useEffect(() => {
    onAuthStateChanged(auth, (_user) => {
      if (_user) {
        getDocs(query(collection(db, "users"), where("uid", "==", _user.uid))).then((querySnapshot) => {
          querySnapshot.forEach(function(doc) {
            setUser(doc.data());
          });
        });
      } else {
        setUser(false);
      }
    });
  }, []);

  return {
    user,
    signin,
    signout,
    googleAuthenticate,
  };

};

// export const signIn = () => {
//   signInAnonymously(auth)
//   .then((u) => {
//     console.log("u", u);
//   })
//   .catch((error) => {
//     const errorCode = error.code;
//     const errorMessage = error.message;
//   });
// }
